/**
 * Early Mega Menu Arrows
 * This script runs immediately to show down arrows for mega menu triggers
 * before the main mega menu JavaScript loads, preventing flash of missing arrows.
 */

(function() {
  'use strict';

  /**
   * Collect all mega menu parent links from section data on the page
   */
  function collectMegaMenuTriggers() {
    const triggers = [];
    
    // Find all script tags with mega menu section data
    const sectionDataScripts = document.querySelectorAll('script[data-section-data]');
    
    sectionDataScripts.forEach(script => {
      try {
        const data = JSON.parse(script.textContent || script.innerText);
        
        // Check if this section has a parent_link (indicates it's a mega menu)
        if (data && data.parent_link) {
          // The parent_link is already handleized in the JSON, so use it directly
          triggers.push(data.parent_link);
        }
      } catch (e) {
        // Ignore invalid JSON
      }
    });
    
    return triggers;
  }

  /**
   * Remove is-arrowless class from mega menu trigger links and add clickable arrows
   */
  function showMegaMenuArrows() {
    const triggers = collectMegaMenuTriggers();
    
    triggers.forEach(trigger => {
      // Find the corresponding navigation item using the same selector as mega menu JS
      const navItem = document.querySelector(
        `.header__menu [data-navlink-handle="${trigger}"], .sticky-header__menu [data-navlink-handle="${trigger}"]`
      );
      
      if (navItem) {
        const link = navItem.querySelector('.header__link');
        
        // Add has-mega-menu class to the parent element (same as mega menu JS does)
        if (!navItem.classList.contains('has-mega-menu')) {
          navItem.classList.add('has-mega-menu');
        }
        
        // Remove is-arrowless class from the link
        if (link && link.classList.contains('is-arrowless')) {
          link.classList.remove('is-arrowless');
        }
        
        // Create clickable arrow element if it doesn't exist
        if (link && !link.querySelector('.mega-menu-arrow-clickable')) {
          const arrowElement = document.createElement('span');
          arrowElement.className = 'mega-menu-arrow-clickable';
          arrowElement.innerHTML = `
            <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          `;
          
          // Add click handler for the arrow
          arrowElement.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            toggleMegaMenu(navItem);
          });
          
          link.appendChild(arrowElement);
        }
      }
    });
  }
  
  /**
   * Toggle mega menu open/closed state
   */
  function toggleMegaMenu(navItem) {
    const isOpened = navItem.classList.contains('is-opened');
    
    // Close all mega menus first
    document.querySelectorAll('.has-mega-menu').forEach(item => {
      item.classList.remove('is-opened');
    });
    document.querySelectorAll('.mega-menu__section').forEach(section => {
      section.classList.remove('is-active');
    });
    
    // If it wasn't opened, open this one
    if (!isOpened) {
      navItem.classList.add('is-opened');
      const megaMenuSection = navItem.querySelector('.mega-menu__section');
      if (megaMenuSection) {
        megaMenuSection.classList.add('is-active');
      }
    }
  }

  /**
   * Add CSS rule to ensure mega menu arrows are visible
   */
  function addMegaMenuArrowCSS() {
    const style = document.createElement('style');
    style.textContent = `
      /* Hide the default pseudo-element arrow for mega menus */
      .has-mega-menu .navbar-link:not(.is-arrowless)::after {
        display: none !important;
      }
      
      /* Style the clickable arrow element */
      .mega-menu-arrow-clickable {
        position: absolute;
        top: 50%;
        right: 0.50rem;
        transform: translateY(-50%);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        transition: transform 0.2s linear;
        z-index: 10;
        color: currentColor;
      }
      
      .has-mega-menu .navbar-link:not(.is-arrowless) {
        padding-right: 2rem !important;
        position: relative;
      }
      
      /* Arrow rotation states for mega menu */
      .dropdown-click--false .has-mega-menu:hover .mega-menu-arrow-clickable,
      .has-mega-menu.is-opened .mega-menu-arrow-clickable {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Ensure the arrow doesn't interfere with text selection */
      .mega-menu-arrow-clickable svg {
        pointer-events: none;
        width: 12px;
        height: 8px;
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * Prevent default mega menu click behavior on text links
   */
  function preventDefaultMegaMenuClicks() {
    // Add click handler to mega menu links to allow normal navigation on text clicks
    document.addEventListener('click', function(e) {
      const link = e.target.closest('.has-mega-menu .header__link');
      if (link && !e.target.closest('.mega-menu-arrow-clickable')) {
        // This is a click on the text part of a mega menu link
        // Allow normal navigation by not preventing default
        return;
      }
    });
  }

  /**
   * Initialize the script
   */
  function init() {
    // Add CSS rule first
    addMegaMenuArrowCSS();
    
    // Set up click prevention
    preventDefaultMegaMenuClicks();
    
    // Run immediately if DOM is ready, or wait for DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showMegaMenuArrows);
    } else {
      // DOM is already ready, run immediately
      showMegaMenuArrows();
    }
  }

  // Initialize when script loads
  init();

})();
